import { ResponseBody } from "./ResponseBody"
export class UpdateResponse extends ResponseBody{
    passwordreset:string
    role: string
    menuid: number
}